import { createApp } from "vue";
import { CONFIG } from "../config";
import BfvImage from "../BfvImage";
import resultTemplate from "../../../templates/partials/organisms/ST08_Searchresult-list/vue-result-template.hbs";

class BfvSearchresults {
  constructor(options = {}) {
    const vue = {
      results: {
        template: resultTemplate,
        el: "#bfv-searchresults__results",
      },
    };

    this.$root = options.element;
    this.data = null;
    this.loadMoreText = this.$root.getAttribute("data-load-more-text");

    this.resultComponentInitalData = {
      wrapperClass: this,
      results: [],
      loading: true,
      isInitialCall: false,
      nextResults: null,
      loadMoreText: this.loadMoreText,
    };

    this.apiRoute = this.$root.getAttribute("data-api-route");
    this.infothekTeaserText = this.$root.getAttribute(
      "data-infothek-teaser-text",
    );
    this.infothekTeaserUrl = this.$root.getAttribute(
      "data-infothek-teaser-url",
    );
    this.infothekTeaserTitle = this.$root.getAttribute(
      "data-infothek-teaser-title",
    );
    this.$totalHits = this.$root.querySelector(".js-total-hits");

    this.initVueComponents(vue);
  }

  init() {
    this.loadData();
    if (this.vueResultComponent.isInitialCall && this.data.totalHits) {
      window.wtDataLayer.numberOfSearchResults += parseInt(
        this.data.totalHits,
        10,
      );
    }
  }

  /**
   * update the views after new data is loaded
   */
  dataLoaded() {
    this.vueResultComponent.updateData(this.data);
    this.updateTotalHits();
  }

  initVueComponents(vueOptions) {
    const self = this;

    this.vueResultComponent = createApp({
      template: vueOptions.results.template,
      data() {
        return { ...self.resultComponentInitalData, isInitialCall: true };
      },
      props: [],
      methods: {
        loadMore() {
          self.loadMore();
        },
        updateData(newData) {
          Object.assign(this.$data, self.resultComponentInitalData, newData);
        },
      },
      updated() {
        this.$nextTick(() => {
          const resultArray = this.$refs.result;
          self.loadImages(resultArray);
        });
      },
    }).mount(vueOptions.results.el);
  }

  /**
   * event happening on Button Click
   */
  loadMore() {
    this.loadData(this.data.nextResults);
  }

  /**
   * connect to Api and load the Data
   * @param loadNextResults - if set, it already contains the apiRoute
   */
  loadData(loadNextResults = "") {
    if (!this.apiRoute) {
      console.error("Please specify an API Route");
      return;
    }

    this.data = { ...this.data, loading: true };

    window.divae.restApi
      .loadData(loadNextResults || this.apiRoute)
      .then((_response) => {
        const response = _response;
        if (loadNextResults) {
          response.results = this.data.results.concat(response.results);
        }
        this.data = response;
        if (!this.teaserCreated) {
          const infothekTeaser = this.createInfothekTeaser();
          this.data.results.splice(2, 0, infothekTeaser);
        }
        this.data.loading = false;
        this.dataLoaded();
      })
      .catch(() => {
        this.data.loading = false;
      });
  }

  /**
   * create Infothek teaser object, which can be added to query results
   * @returns {{text: string, href: string, isInfothekTeaser: boolean}}
   */
  createInfothekTeaser() {
    this.teaserCreated = true;
    return {
      text: this.infothekTeaserText,
      href: this.infothekTeaserUrl,
      title: this.infothekTeaserTitle,
      isInfothekTeaser: true,
    };
  }

  /**
   * images don't get loaded automatically so we must do it manually
   * @param resultArray
   */
  loadImages(resultArray = []) {
    resultArray.forEach(($result) => {
      const $images = $result.querySelectorAll(
        '.bfv-image__loader[data-module="BfvImage"]',
      );
      Array.prototype.slice.call($images).forEach(($image) => {
        if (!$image.classList.contains("bfv-image--load-finished")) {
          const newImage = new BfvImage({ element: $image });
          newImage.disableAutoLoad = true;
          newImage.init();
        }

        const event = document.createEvent("event");
        event.initEvent(CONFIG.events.BFV_IMAGE_LOAD, false, true);
        $image.dispatchEvent(event);
      });
    });
  }

  /**
   * update the number of hits
   */
  updateTotalHits() {
    if (this.data.totalHits) {
      this.$totalHits.innerText = this.data.totalHits;
      this.$totalHits.classList.add("visible");
    } else {
      this.$totalHits.classList.remove("visible");
    }
  }
}

export default BfvSearchresults;

